export default "__VITE_ASSET__D9RsRe0e__"